import { render, staticRenderFns } from "./QuestionEditDocuments.vue?vue&type=template&id=05004454&"
import script from "./QuestionEditDocuments.vue?vue&type=script&lang=js&"
export * from "./QuestionEditDocuments.vue?vue&type=script&lang=js&"
import style0 from "./QuestionEditDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports